import HTTP from "@/_helpers/http";
import { ADMINS__API } from "@/_helpers/urls";
import { ADMINS__MUTATIONS } from "../mutation-types";
import { ADMINS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

 
// State
const state = {
  admins: [],
  loggedAdmin: null,
  roles: [],
  countries: [],
  adminloginactivities: [],
  allModulesAndSubmodules: [],
};

// Getters
const getters = {};

// Mutations
const mutations = {
  [ADMINS__MUTATIONS.GETADMINS](state, data) {
    state.admins = data;
  },
  [ADMINS__MUTATIONS.GETADMIN](state, data) {
    state.loggedAdmin = data;
  },
  [ADMINS__MUTATIONS.GETROLES](state, data) {
    state.roles = data.roles;
    state.countries = data.countries;
  },
  [ADMINS__MUTATIONS.GETLOGINACTIVITIES](state, data) {
    state.adminloginactivities = data;
  },
  [ADMINS__MUTATIONS.GETALLMODULES](state, data) {
    state.allModulesAndSubmodules = data;
  },
};

// Actions
const actions = {
  async [ADMINS__ACTIONS.GETADMINS]({ commit }) {
    try {
      const url = `${ADMINS__API.GETADMINS}`;
      const response = await HTTP().get(url);
      commit(ADMINS__MUTATIONS.GETADMINS, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [ADMINS__ACTIONS.GETALLMODULES]({ commit }) {
    try {
      const url = `${ADMINS__API.GETALLMODULES}`;
      const response = await HTTP().get(url);
      commit(ADMINS__MUTATIONS.GETALLMODULES, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [ADMINS__ACTIONS.GETADMIN]({ commit }) {
    try {
      const url = `${ADMINS__API.GETADMIN}`;
      const response = await HTTP().get(url);
      commit(ADMINS__MUTATIONS.GETADMIN, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [ADMINS__ACTIONS.GETLOGINACTIVITIES]({ commit }) {
    try {
      const url = `${ADMINS__API.GETLOGINACTIVITIES}`;
      const response = await HTTP().get(url);
      commit(ADMINS__MUTATIONS.GETLOGINACTIVITIES, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [ADMINS__ACTIONS.GETROLES]({ commit }) {
    try {
      const url = `${ADMINS__API.GETROLES}`;
      const response = await HTTP().get(url);
      commit(ADMINS__MUTATIONS.GETROLES, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [ADMINS__ACTIONS.CREATEADMIN]({ commit, dispatch }, data) {
    try {
      const url = `${ADMINS__API.CREATEADMIN}`;
      const response = await HTTP().post(url, data);
      if (response.status === 200) {
        await dispatch(ADMINS__ACTIONS.GETADMINS);
        toast.success("Admin created successfully");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to create admin");
    }
  },

  async [ADMINS__ACTIONS.UPDATEADMIN]({ commit, dispatch }, data) {
    try {
      const url = `${ADMINS__API.UPDATEADMIN}`;
      const response = await HTTP().post(url, data);
      if (response.status === 200) {
        await dispatch(ADMINS__ACTIONS.GETADMINS);
        toast.success("Admin updated successfully");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to update admin");
    }
  },

  async [ADMINS__ACTIONS.CHANGETHEME]({ commit, dispatch }, data) {
    try {
      const url = `${ADMINS__API.CHANGETHEME}`;
      const response = await HTTP().post(url, data);

      if (response.status === 200) {
        await dispatch(ADMINS__ACTIONS.GETADMINS);
        toast.success(response.data.message);
        return {
          success: true,
          status: 200,
        };
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed To Update Theme");
      return {
        success: false,
        status: error.response?.status || 500,
      };
    }
  },

  async [ADMINS__ACTIONS.DELETEADMIN]({ commit, dispatch }, parameter) {
    try {
      const url = `${ADMINS__API.DELETEADMIN}/${parameter.id}`;
      const response = await HTTP().delete(url);
      toast.success("Admin deleted successfully");
      await dispatch(ADMINS__ACTIONS.GETADMINS);
    } catch (error) {
      console.log(error);
      toast.error("Failed to delete admin");
    }
  },

  async [ADMINS__ACTIONS.CREATEPERMISSION]({ commit, dispatch }, data) {
    try {
      const url = `${ADMINS__API.CREATEPERMISSION}`;
      const response = await HTTP().post(url, data);
      if (response.data.status === 200) {
        toast.success("Admin created successfully");
        return;
      }
      await dispatch(ADMINS__ACTIONS.GETADMINS);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
